import axios from 'axios';

export const fetchImageset = (projectId, imagesetId) => axios.get(`/projects/${projectId}/image_sets/${imagesetId}`);
export const fetchChatLikes = (projectId, imagesetId) => axios.get(`/projects/${projectId}/image_sets/${imagesetId}/likes`);
export const postChatLike = (projectId, imagesetId) => axios.post(`/projects/${projectId}/image_sets/${imagesetId}/like`);
export const deleteChatLike = (projectId, imagesetId) => axios.delete(`/projects/${projectId}/image_sets/${imagesetId}/like`);
export const fetchChatComments = (projectId, imagesetId) => axios.get(`/projects/${projectId}/image_sets/${imagesetId}/comments`);
export const postChatComment = (projectId, imagesetId, body) => axios.post(`/projects/${projectId}/image_sets/${imagesetId}/comment`, body);
export const deleteChatComment = (projectId, imagesetId, id) => axios.delete(`/projects/${projectId}/image_sets/${imagesetId}/comment?comment[id]=${id}`);
export const fetchImageSetReportStatus = (projectId, imagesetId) => axios.get(`/projects/${projectId}/image_sets/${imagesetId}/report_status`);

export default {
  fetchImageset,
  fetchChatLikes,
  postChatLike,
  deleteChatLike,
  fetchChatComments,
  postChatComment,
  deleteChatComment,
  fetchImageSetReportStatus
};
